module.exports = __webpack_public_path__ + "img/回收站在途库存数.add6a4fd.png";